import React, { useEffect } from "react";
import "../assets/css/cxda.css";
import "aos/dist/aos.css";
import AOS from "aos";
import "bootstrap/dist/css/bootstrap.min.css";

import member1 from "../assets/team.png";
import member2 from "../assets/team2.png";
import member3 from "../assets/team3.png";
import member4 from "../assets/team4.png";

const teamMembers = [
  {
    name: "Ahmed Qadir Al Balushi",
    role: "Chairman",
    img: member1,
  },
  {
    name: "Sarfaraz Mazher",
    role: "Financial Senior Manager | Banking & Credit Specialist",
    img: member2,
  },
  {
    name: "Bharat Manwani",
    role: "Senior Financial Advisor",
    img: member3,
  },
  {
    name: "Ammar Al Balushi",
    role: "Marketing Manager",
    img: member4,
  },
];

const OmanTeam = () => {
  useEffect(() => {
        AOS.init({ duration: 1000 });
      }, []);
  return (
    <section className="oman-team-section pb-2" data-aos="fade-up">
      <div className="container">
        <h2 className="text-center fw-bold mb-4 text-danger">Oman Team</h2>

        <div className="row text-center">
          {teamMembers.map((member, index) => (
            <div key={index} className="col-12 col-md-6 col-lg-3 mb-4">
              <div className="team-card p-4">
                <img
                  src={member.img}
                  alt={member.name}
                  className="rounded-circle mb-3 team-img"
                />
                <h5 className="fw-bold  mb-2">{member.name}</h5>
                <p className=" mb-0">{member.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OmanTeam;
